<template>
    <div id="form-settings">
        <div class="settings-menu">
            <div
                class="menu-item"
                :class="{ active: activeItem === 0 }"
                @click="setActive(0)"
            >
                <i class="icon md-icon">settings</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formSettings.formSettings") }}</div>
                    <div class="description">{{ $t("form.formSettings.changeFormStateAndProperties") }}</div>
                </div>
            </div>
            <div
                class="menu-item"
                :class="{ active: activeItem === 1 }"
                @click="setActive(1)"
            >
                <i class="icon md-icon">confirmation_number</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.redicetFormAnswer") }}</div>
                    <div class="description">{{ $t("form.redicetFormAnswerDesc2") }}</div>
                </div>
            </div>
            <div
                class="menu-item disabled"
                :class="{ active: activeItem === 2 }"
            >
                <i class="icon md-icon">mail</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formSettings.emails") }}</div>
                    <div class="description">{{ $t("form.formSettings.emailsDesc") }}</div>
                </div>
            </div>
            <div
                class="menu-item disabled"
                :class="{ active: activeItem === 3 }"
            >
                <i class="icon md-icon">account_tree</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formSettings.conditions") }}</div>
                    <div class="description">{{ $t("form.formSettings.conditionsDesc") }}</div>
                </div>
            </div>
            <div
                class="menu-item disabled"
                :class="{ active: activeItem === 4 }"
            >
                <i class="icon md-icon">thumb_up</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formSettings.thankYouPage") }}</div>
                    <div class="description">{{ $t("form.formSettings.thankYouPageDesc") }}</div>
                </div>
            </div>
            <div
                class="menu-item disabled"
                :class="{ active: activeItem === 5 }"
            >
                <i class="icon md-icon">integration_instructions</i>
                <div class="menu-text">
                    <div class="title">{{ $t("form.formSettings.integretions") }}</div>
                    <div class="description">{{ $t("form.formSettings.integretionsDesc") }}</div>
                </div>
            </div>
        </div>
        <div class="content">
            <!--            display: flex;-->
            <!--            justify-content: center;-->
            <FormDetail
                v-if="activeItem === 0"
                :formId="formId"
                :siteId="siteId"
            />
            <FormOrientation
                v-else-if="activeItem === 1"
                :formId="formId"
                :siteId="siteId"
            />
        </div>
    </div>
</template>

<script>
import FormDetail from "./FormDetail.vue";
import FormOrientation from "./FormOrientation.vue";

export default {
    name: "Settings",
    props: {
        formId: {
            type: String,
            required: true,
        },
        siteId: {
            type: String,
            required: true,
        },
    },
    components: {
        FormDetail,
        FormOrientation,
    },
    data() {
        return {
            activeItem: 0,
        };
    },
    methods: {
        setActive(index) {
            this.activeItem = index;
        },
    },
};
</script>

<style lang="scss" scoped>
#form-settings {
    display: flex;
    height: 100%;
    font-family: 'Roboto', sans-serif;

    .settings-menu {
        width: 300px;
        height: 100vh;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        overflow-y: auto;
        border-right: 1px solid #dcdcdc;
    }

    .menu-item {
        display: flex;
        align-items: center;
        background-color: #ffffff;
        padding: 1rem;
        border-radius: 0.5rem;
        cursor: pointer;
        transition: background-color 0.3s, transform 0.3s, box-shadow 0.3s;

        &.active {
            border: 2px solid #ff9830;
        }

        &:hover {
            background-color: #e0e0e0;
            transform: translateY(-2px);
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .icon {
            font-size: 1.5rem;
            margin-right: 1rem;
            color: #666;
            width: 24px;
            display: flex;
            justify-content: center;
        }

        .menu-text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;

            .title {
                font-weight: bold;
                font-size: 1rem;
                color: #333;
            }

            .description {
                font-size: 0.875rem;
                color: #666;
            }
        }

    }

    .disabled {
        display: none;
        opacity: 0.5;
        pointer-events: none;
    }


    .content {
        width: calc(100% - 300px);
        padding: 1rem;
    }
}


</style>
